/** Staff roles and the one admin area each may use — mirror of backend/auth/roles.py (home paths).
 *  Used by the admin layout gate, the post-login redirect and proxy.ts route scoping. */
export const STAFF_ROLES = [
    'admin', 'editor', 'agency_content_editor', 'ticket_scanner', 'driver', 'service_staff', 'reception', 'housekeeping',
] as const;

export type StaffRole = (typeof STAFF_ROLES)[number];

export function isStaffRole(role: unknown): role is StaffRole {
    return typeof role === 'string' && (STAFF_ROLES as readonly string[]).includes(role);
}

/** Where each narrow role lands; admin and editor have their own wider areas. */
export const ROLE_HOME: Record<StaffRole, string> = {
    admin: '/admin',
    editor: '/admin/articles',
    agency_content_editor: '/admin/agency-content',
    ticket_scanner: '/admin/checkin',
    driver: '/admin/kierowca/trasy',
    service_staff: '/admin/zaklad',
    reception: '/admin/noclegi',
    housekeeping: '/admin/noclegi/pokoje',
};

/** Admin paths a narrow role may open (exact path or below it). null = not scoped here. */
export const ROLE_AREAS: Partial<Record<StaffRole, string[]>> = {
    agency_content_editor: ['/admin/agency-content'],
    ticket_scanner: ['/admin/checkin'],
    service_staff: ['/admin/zaklad'],
    driver: ['/admin/kierowca/trasy'],
    // Front desk: the room board, reservations and room statuses — no prices or settings.
    reception: ['/admin/noclegi/rezerwacje', '/admin/noclegi/pokoje'],
    housekeeping: ['/admin/noclegi/pokoje'],
};

export function roleMayOpen(role: StaffRole, pathname: string): boolean {
    if (role === 'reception' && pathname === '/admin/noclegi') return true;   // the board itself (exact)
    const areas = ROLE_AREAS[role];
    if (!areas) return true;
    return areas.some((p) => pathname === p || pathname.startsWith(p + '/'));
}
